import Axios from "axios";

export default {
    async updateAttachment(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}record/save-attachment`,
            params
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
